import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import NormativeForm from '../Forms/NormativeForm';

const AddEditNormativeModal = ({
	dataNormative,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Normativa
			</ModalHeader>

			{/* <div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>Información General</NavLink>
					</NavItem>
				</Nav>
			</div> */}

			<NormativeForm
				dataNormative={dataNormative}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditNormativeModal;
